import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { SiteReviewService } from 'app/services/site-review.service';

@Component({
  selector: 'app-wb-expanded-search',
  standalone: false,
  templateUrl: './wb-expanded-search.html',
  styleUrl: './wb-expanded-search.scss'
})
export class WbExpandedSearch {

  searchByOption = '';
  searchInput: string = '';
  startDateRange: Date;
  endDateRange: Date;
  activeSearch: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<WbExpandedSearch>,
    private siteRevService: SiteReviewService,
    private toastr: ToastrService
  ) { }

  onSearchByChange(event: any) {
    this.searchByOption = event.value;
  }

  search() {
    if (!this.searchInput?.trim()) {
      this.activeSearch = false;
      this.dialogRef.close();
      return;
    }

    this.activeSearch = true;

    const parsedInput = this.searchInput
      .split(/[\n;,]+/)
      .map(input => input.trim())
      .filter(input => input)
      .join(', ');

    const searchParams = {
      input: parsedInput,
      searchBy: this.searchByOption,
      startDate: this.startDateRange,
      endDate: this.endDateRange
    };

    this.siteRevService.wbExpandedSearch(searchParams)
      .pipe(
        catchError(error => {
          console.error('Error during wbExpandedSearch:', error);
          this.toastr.error('Error during search', 'Error');
          return of(null); 
        }),
        finalize(() => {
          this.activeSearch = false;   
        })
      )
      .subscribe(res => {
        if (res) {
          const resultObj = {
            data: res,
            searchBy: this.searchByOption,
            searchInput: this.searchInput,
            startDate: this.startDateRange,
            endDate: this.endDateRange
          };
          this.dialogRef.close(resultObj);
        } else {
          this.dialogRef.close();
        }
      });
  }

  close() {
    this.activeSearch = false;
    this.dialogRef.close();
  }
}